export default "__VITE_PUBLIC_ASSET__926b8712__"